import { render } from "./ArrowRightWhite.vue?vue&type=template&id=80e5e690"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowRightWhite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80e5e690"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80e5e690', __exports__)) {
    api.reload('80e5e690', __exports__)
  }
  
  module.hot.accept("./ArrowRightWhite.vue?vue&type=template&id=80e5e690", () => {
    api.rerender('80e5e690', render)
  })

}


export default __exports__